import { render, staticRenderFns } from "./FoamBoxLeftSVG.vue?vue&type=template&id=6713016e&scoped=true"
import script from "./FoamBoxLeftSVG.vue?vue&type=script&lang=js"
export * from "./FoamBoxLeftSVG.vue?vue&type=script&lang=js"
import style0 from "./FoamBoxLeftSVG.vue?vue&type=style&index=0&id=6713016e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6713016e",
  null
  
)

export default component.exports